import { Loader2 } from "lucide-react";

import { Button } from "@/components/ui";
import type { PoolValue } from "@/lib/attributeReview/valueView";

type Props = {
  values: PoolValue[];
  storeValueCount: number;
  busy: boolean;
  onClick: () => void;
};

const unmatched = (v: PoolValue) =>
  !v.ignored && (!v.pool_value || v.match === "not checked");

export function MapValuesButton({
  values,
  storeValueCount,
  busy,
  onClick,
}: Props) {
  const first = values.length === 0;
  const count = first ? storeValueCount : values.filter(unmatched).length;
  if (count === 0) return null;
  return (
    <Button
      type="button"
      className="self-start"
      variant={first ? "default" : "outline"}
      size={first ? "md" : "sm"}
      disabled={busy}
      onClick={onClick}
    >
      {busy && <Loader2 className="h-4 w-4 animate-spin" />}
      {busy
        ? `Mapping ${count} values…`
        : first
          ? `Map ${count} values with AI`
          : `Ask AI again for ${count} values`}
    </Button>
  );
}
